import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { toggleModalDiagramRename, diagramRename } from '../../../redux/main/main.actions';
import { selectIsModalDiagramRenameEnabled, selectModalDiagramRenameData } from '../../../redux/main/main.selectors';

import { trackEvent } from '../../../lib/analytics';

import Modal from '../Modal/Modal';
import './ModalDiagramRename.scss';

export const ModalDiagramRename = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const isOpen = useSelector(selectIsModalDiagramRenameEnabled);
    const modalData = useSelector(selectModalDiagramRenameData);

    const inputRef = useRef(null);
    const [value, setValue] = useState(modalData?.diagram?.title || '');

    useEffect(() => {
        if (!modalData?.diagram?.title) return;

        if (value !== modalData?.diagram?.title) {
            setValue(modalData?.diagram?.title || '');
        }
        return () => { };
    }, [modalData]);

    const handleSave = () => {
        trackEvent('app_modal_diagram_rename_submit', {
            page: 'app',
            type: 'modals',
        });
        const updatedValue = value || 'Untitled';
        // setValue(updatedValue);
        dispatch(diagramRename(modalData?.diagram?.id, { title: updatedValue }));
        dispatch(toggleModalDiagramRename(null));

        setTimeout(() => {
            setValue(modalData?.diagram?.title || '');
        }, 300);
    };

    const handleCancel = () => {
        dispatch(toggleModalDiagramRename(null));
        setTimeout(() => {
            setValue(modalData?.diagram?.title);
        }, 300);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSave();
        }
    };

    const handleRender = () => {
        if (isOpen && inputRef.current) {
            inputRef.current.focus();
            inputRef.current.select();
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            modalClass={`modal-diagram-rename`}
            onCancel={handleCancel}
            onShouldRender={handleRender}
        >
            <div className="modal-content-header">{t('m_diagram_rename.header')}</div>
            <div className="modal-content-body">

                <div className="description-text">{t('m_diagram_name.enter_new_name')}</div>

                <input
                    maxLength="1000"
                    ref={inputRef}
                    autoComplete="off"
                    spellCheck="false"
                    type="text"
                    id="diagram-name"
                    placeholder={t('m_diagram_name.enter_new_name')}
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    onKeyDown={handleKeyDown}
                />
                <div className='buttons-wrap'>
                    <button className='button-second' onClick={() => handleCancel()}>{t('b.cancel')}</button>
                    <button onClick={() => handleSave()}>{t('b.rename')}</button>
                </div>
            </div>
        </Modal>
    );
};

export default ModalDiagramRename;
